import { render, staticRenderFns } from "./detection.vue?vue&type=template&id=2541e802&scoped=true&"
import script from "./detection.vue?vue&type=script&lang=ts&"
export * from "./detection.vue?vue&type=script&lang=ts&"
import style0 from "./detection.vue?vue&type=style&index=0&id=2541e802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2541e802",
  null
  
)

export default component.exports